import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import DashSummary from "../../components/agent-ui/DashSummary";
import ReusableTable from "../../utils/ReusableTable";
import { ArrowRight2 } from "iconsax-react";
import "./dev.css";
import { useNavigate } from "react-router-dom";
import { AxiosAuthGet } from "../../api/api";

const DevDash = () => {
  const navigate = useNavigate();
  const [searchInp, 
    // setSearchInp
  ] = useState("");
  const [isPropLoad, setisPropLoad] = useState(false);
  const [isStatLoad, setIsStatLoad] = useState(false);
  const [statData, setStatData] = useState();
  const [propData, setPropData] = useState([]);
  const url = `developer/dashboard/properties/?search=${searchInp}&page=1&page_size=5`;
  const statUrl = `developer/dashboard/stats/`;

  const eachSum = [
    {
      total: statData?.estateCount,
      text: "Number of Estates",
    },
    {
      total: statData?.propertiesCount,
      text: "Number of Properties",
    },
    {
      total: statData?.buildingsCount,
      text: "Buildings",
    },
    {
      total: statData?.customersCount,
      text: "Total Customers",
    },
    {
      total: statData?.landsCount,
      text: "Total Lands",
    },
  ];

  const tableData = [
    "#",
    "Name",
    "Type",
    "Estate",
    "Date Added",
    "Status",
    "Action",
  ];

  const addProp = () => {
    localStorage.removeItem("editProp");
    navigate("/dev_dash/property/property-add/");
  };

  const clickProp = (row) => {
    localStorage.setItem("singleProp", JSON.stringify(row));
    navigate(`/dev_dash/property/single-view/`);
  };

  const clickSeeAll = () => {
    navigate(`/dev_dash/property`);
  };

  const getProp = () => {
    setisPropLoad(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setPropData(res?.data);
        setisPropLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setisPropLoad(false);
      });
  };
  const getStat = () => {
    setIsStatLoad(true);
    AxiosAuthGet(statUrl)
      .then((res) => {
        // console.log(res);
        setStatData(res?.data);
        setIsStatLoad(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsStatLoad(false);
      });
  };

  useEffect(() => {
    getProp();
    getStat();
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <AgentHeader
        header={"Dashboard"}
        btnText={"Add Property"}
        placeholder={"Search for property"}
        isSearch
        btnClick={addProp}
      />
      <DashSummary eachSum={eachSum} loading={isStatLoad} />
      <div className="dash_table">
        <div className="dash_head">
          <div className="dash_head_left">
            <h3>Most Recently Added Properties</h3>
            <p>Latest properties added to your portfolio</p>
          </div>
          <div
            className="dash_head_right"
            onClick={clickSeeAll}
          >
            <p>See All</p>
            <ArrowRight2 size="12" color="#737475" />
          </div>
        </div>
        <div className={isPropLoad ? "opacity" : ""}>
          <ReusableTable
            columns={tableData}
            data={propData}
            clickView={clickProp}
          />
        </div>
      </div>
    </div>
  );
};

export default DevDash;
